import { render, staticRenderFns } from "./BuySubscriptionFormView.vue?vue&type=template&id=f9055a4c&scoped=true&"
import script from "./BuySubscriptionFormView.vue?vue&type=script&lang=js&"
export * from "./BuySubscriptionFormView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9055a4c",
  null
  
)

export default component.exports